import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import HayaSelect from "components/woof-haya-select"
import memo from "set-state-compare/build/memo"
import React from "react"
import SelectContainer from "./select-container"
import useInput from "@kaspernj/api-maker/build/use-input"

/** @typedef {object} ComponentsAdminSelectProps */

/** @typedef {object} ComponentsAdminSelectState */

/**
 * @extends {ShapeComponent<ComponentsAdminSelectProps, ComponentsAdminSelectState>}
 */
class ComponentsAdminSelect extends ShapeComponent {
  setup() {
    const {inputProps, restProps, wrapperOpts} = useInput({props: this.props})
    const {containerProps, ...actualRestProps} = restProps

    this.inputProps = inputProps
    this.restProps = actualRestProps
    this.wrapperOpts = wrapperOpts
  }

  render() {
    const {inputProps, restProps} = this.tt
    const {ref, type, ...restInputProps} = inputProps

    return (
      <SelectContainer {...this.props}>
        <HayaSelect {...restInputProps} {...restProps} />
      </SelectContainer>
    )
  }
}

export default memo(shapeComponent(ComponentsAdminSelect))
